import $ from "jquery";
import { InCoreSwal2, InCoreSwal2Icon } from "./swal.utils";
import { InCoreToast, InCoreToastCustom, InCoreToastType, InCoreToastDefault } from "./toast.utils";

/**
 * Initializes the notification system and displays a notification if inputs are present.
 */
export function InCoreNotifier(): void {
    const notificationMessageInput = $("#notification_message");
    const notificationTypeInput = $("#notification_type");
    const notificationModeInput = $('#notification_mode');
    const notificationOnClickInput = $('#notification_onclick');

    if (notificationMessageInput.length > 0 && notificationTypeInput.length > 0) {
        const notificationMessage = notificationMessageInput.val()?.toString().trim();
        const notificationType = notificationTypeInput.val()?.toString().trim();
        const notificationMode = notificationModeInput.val()?.toString().trim();
        const notificationOnClick = notificationOnClickInput.val()?.toString().trim();

        if (notificationMessage && notificationType) {
            if (notificationMode === 'SWAL2') {
                if (notificationType in InCoreSwal2Icon) {
                InCoreSwal2(InCoreSwal2Icon[notificationType as keyof typeof InCoreSwal2Icon], notificationMessage);
                }
            }
            else if (notificationMode === 'TOAST') {
                if (notificationOnClick !== '') {
                    var delta: any = InCoreToastDefault;
                    delta.onclick = function () { window.open(notificationOnClick); };
                    InCoreToastCustom(InCoreToastType[notificationType as keyof typeof InCoreToastType], notificationMessage, delta);
                }
                else {
                    InCoreToast(InCoreToastType[notificationType as keyof typeof InCoreToastType], notificationMessage);
                }
            }
            else {
                InCoreSwal2(InCoreSwal2Icon[notificationType as keyof typeof InCoreSwal2Icon], notificationMessage);
            }
        }
    }
}

// Automatically initialize the notification system on page load
$(() => InCoreNotifier());